import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";
import React from "react";

interface Props {
  value: server.dto.Region[]
  onToggle: (region: server.dto.Region) => void
}

const Region = (props: Props) => {
  const selectedRegions = new Set(props.value.map(region => region.value));

  return <>
    {serverReference.regions.map(region => (
      <div key={region.value} className="margin-bottom-small">
        <Checkbox
          keyboardNavigationOptions={VerticalKeyboardNavigationGroup("region")}
          checked={selectedRegions.has(region.value)}
          label={region.text}
          onChange={() => { props.onToggle(region); }}
        />
      </div>
    ))}
  </>;
};

export default Region;